import { render } from "./tagManage.vue?vue&type=template&id=75ad4a74&scoped=true&ts=true"
import script from "./tagManage.vue?vue&type=script&lang=ts"
export * from "./tagManage.vue?vue&type=script&lang=ts"

import "./tagManage.vue?vue&type=style&index=0&id=75ad4a74&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ad4a74"]])

export default __exports__